module.exports = __webpack_public_path__ + "static/media/user-im1.43a115f5.png";